import { gql, MutationHookOptions, useMutation } from "@apollo/client";

import { ReportFragment, REPORT_FRAGMENT } from "../../fragments";
import { FillReportMutationVariables } from "../../types";

export const FILL_REPORT = gql`
  mutation fillReport($input: FillReportInput!) {
    fillReport(input: $input) {
      report {
        ...ReportFragment
      }
    }
  }
  ${REPORT_FRAGMENT}
`;

export type ReportData = { fillReport: { report: ReportFragment } };

export default (
  options?: MutationHookOptions<ReportData, FillReportMutationVariables>
) => {
  return useMutation<ReportData, FillReportMutationVariables>(
    FILL_REPORT,
    options
  );
};
